import { COMPANY_CONFIGS } from "@/config/companies";
import { CompanyProfile } from "@/components/company-portal/CompanyProfile";

export default function InnoventureProfile() {
  const config = COMPANY_CONFIGS.innoventure;
  return <CompanyProfile config={config} />;
}
